import React from 'react';
import { useNavigate } from 'react-router-dom';
import kondifyLogo from '../assets/Kondify letra negra sin fondo recortada.png';
import './LandingScreen.css';

const AvisoPrivacidadScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="landing-container" style={{ background: '#F8FAFC', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* --- NAVBAR SIMPLIFICADO --- */}
            <header className="landing-header" style={{ position: 'sticky', top: 0, background: '#ffffff', borderBottom: '1px solid #E2E8F0', zIndex: 100 }}>
                <div className="landing-nav-content" style={{ display: 'flex', justifyContent: 'between', alignItems: 'center' }}>
                    <div className="landing-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img 
                            src={kondifyLogo} 
                            alt="Kondify" 
                            className="landing-logo-img" 
                        />
                    </div>
                    <button 
                        onClick={() => navigate('/')} 
                        style={{
                            background: '#7E66FC',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '20px',
                            padding: '8px 20px',
                            fontSize: '0.88rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Volver a la Web
                    </button>
                </div>
            </header>

            {/* --- CONTENIDO PRINCIPAL --- */}
            <main style={{ flex: 1, padding: '64px 24px', maxWidth: '840px', margin: '0 auto', width: '100%' }}>
                <h1 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '800', 
                    marginBottom: '8px', 
                    background: 'linear-gradient(135deg, #7E66FC 0%, #F59E0B 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '-0.03em'
                }}>
                    Aviso de Privacidad
                </h1>
                <p style={{ color: '#475569', fontSize: '1rem', lineHeight: '1.6', marginBottom: '32px' }}>
                    En <strong>Kondify</strong> estamos comprometidos con la protección de tus datos personales. 
                    Este documento describe cómo recopilamos, usamos y resguardamos la información de administradores, condóminos y visitantes.
                </p>

                <div style={{ 
                    background: '#ffffff', 
                    border: '1px solid #E2E8F0', 
                    borderRadius: '24px', 
                    padding: '40px', 
                    color: '#334155',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)',
                    lineHeight: '1.8', 
                    fontSize: '0.95rem' 
                }}>
                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginBottom: '12px' }}>1. Responsable del Tratamiento de sus Datos Personales</h2>
                    <p><strong>Kondify</strong>, con domicilio de contacto en Jalisco, México, y correo electrónico <strong>ventas@kondify.mx</strong>, es el responsable del uso y protección de sus datos personales, de conformidad con lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>2. Datos Personales que Recopilamos</h2>
                    <p>Para llevar a cabo las finalidades descritas en el presente Aviso de Privacidad, recabaremos los siguientes datos personales:</p>
                    <ul style={{ paddingLeft: '20px', margin: '12px 0' }}>
                        <li>Datos de identificación y contacto: Nombre completo, dirección de correo electrónico, número de teléfono.</li>
                        <li>Datos de la organización: Nombre del condominio, fraccionamiento o desarrollo residencial administrado, número de unidades o casas habitacionales.</li>
                        <li>Datos de facturación (en caso de contratación): Registro Federal de Contribuyentes (RFC), domicilio fiscal y régimen tributario.</li>
                        <li>Datos audiovisuales: Grabación de voz y video de las sesiones de demostración o soporte en línea (realizadas a través de Google Meet o plataformas similares mediante herramientas de minutas de inteligencia artificial).</li>
                    </ul>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>3. Finalidades del Tratamiento de los Datos</h2>
                    <p>Los datos personales que recabamos de usted serán utilizados para las siguientes finalidades principales:</p>
                    <ol style={{ paddingLeft: '20px', margin: '12px 0' }}>
                        <li>Agendar y llevar a cabo las sesiones de demostración personalizada de la plataforma.</li>
                        <li>Registrar y habilitar su cuenta de usuario en el sistema Kondify tras su contratación.</li>
                        <li>Brindar soporte técnico y atención a clientes.</li>
                        <li>Grabar las sesiones de videoconferencia con el único fin de generar transcripciones escritas, minutas de acuerdos internos y control de calidad del servicio de soporte.</li>
                        <li>Realizar los cargos y la facturación correspondiente a los servicios contratados.</li>
                    </ol>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>4. Seguridad y Transferencia de Datos</h2>
                    <p>Nos comprometemos a que sus datos serán tratados bajo las más estrictas medidas de seguridad que garanticen su confidencialidad. Sus datos de pago están procesados y resguardados por la pasarela con certificación internacional Stripe. No realizamos transferencias de sus datos personales a terceros sin su consentimiento expreso, salvo las excepciones previstas en el artículo 37 de la LFPDPPP.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>5. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</h2>
                    <p>Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos se conocen como Derechos ARCO.</p>
                    <p>Para el ejercicio de cualquiera de los derechos ARCO, usted deberá enviar una solicitud por escrito al correo electrónico <strong>ventas@kondify.mx</strong> detallando su petición y adjuntando una identificación oficial vigente.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>6. Modificaciones al Aviso de Privacidad</h2>
                    <p>El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales, de nuestras propias necesidades por los servicios que ofrecemos o de nuestras prácticas de privacidad. Cualquier cambio será publicado directamente en este portal web.</p>
                    
                    <p style={{ marginTop: '40px', fontSize: '0.85rem', color: '#64748B', borderTop: '1px solid #E2E8F0', paddingTop: '20px' }}>Última actualización: Julio de 2026.</p>
                </div>
            </main>
        </div>
    );
};

export default AvisoPrivacidadScreen;
